import { render } from "./Thinking4.vue?vue&type=template&id=3ec395b0"
import script from "./Thinking4.vue?vue&type=script&lang=js"
export * from "./Thinking4.vue?vue&type=script&lang=js"

import exportComponent from "/builds/skilltech-ph/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__